module.exports = __webpack_public_path__ + "static/scale-model-of-world's-largest-longhorn-in-austin-texas-becbb9d8f3b1476d8a4c00f1ab4b3117.png";